import { Path } from '@/main/router/routerPath';

import { VozidloPujcovna } from './vozidloPujcovna';
import { Zapujcky } from './zapujcka';
import { PlanovanaPujcka } from './planovanaPujcka';
import { PredmetPujcovna } from './ostatniPredmety';

export const router = new Path('Pujcovna').addChildren([
	VozidloPujcovna.router,
	Zapujcky.router,
	PlanovanaPujcka.router,
	PredmetPujcovna.router,
]);
